module.exports = __webpack_public_path__ + "img/1f5bc.5b1777d.svg";